module.exports = {"441624100":"阳明镇","441624101":"大坝镇","441624102":"长塘镇","441624103":"下车镇","441624104":"上陵镇","441624105":"优胜镇","441624106":"贝墩镇","441624107":"古寨镇","441624108":"彭寨镇","441624109":"合水镇","441624110":"公白镇","441624111":"青州镇","441624112":"浰源镇","441624113":"热水镇","441624114":"东水镇","441624115":"礼士镇","441624116":"林寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441624.json
// module id = 1866
// module chunks = 0